export const REGEX_MOBILE_NUMBER = /^04\d{8}$/
export const REGEX_MOBILE_NUMBER_OR_EMAIL = /^(04\d{8})|(.+\@.+\..+)$/
export const REGEX_POSTCODE = /^\d{4}$/
